import {
  ADVICE_NAMES,
  InsuranceAdvice,
  PurchaseRecommendation,
  RecommendationReason,
} from "Store/advice/interfaces";

import { getCorrectPayment } from "Store/advice/utils";

export const generateUnavailableMessage = (
  isAdvisor: boolean,
  insurance: {
    name: ADVICE_NAMES;
    title: string;
  },
  adviceUnavailableMessages: any,
  lang: string,
  advice?: InsuranceAdvice,
  // eslint-disable-next-line sonarjs/cognitive-complexity
): { insuranceType: string; message: string } | null => {
  if (!advice) {
    return null;
  }
  const insuranceType =
    adviceUnavailableMessages.insuranceTypes[insurance.title][lang];
  const payment = getCorrectPayment(advice);
  const recommendationCauses = payment.recommendationConfiguration.causes ?? [];
  const causesAsString = getCausesAsString(
    insurance.title,
    recommendationCauses,
    adviceUnavailableMessages,
    lang,
    isAdvisor,
  );

  let message = "";
  switch (payment.recommendationConfiguration.recommendation) {
    case PurchaseRecommendation.CHECK_DISABILITY_PENSION_AND_PURCHASE:
      if (
        recommendationCauses.includes(RecommendationReason.DISABILITY_PENSION)
      ) {
        message =
          adviceUnavailableMessages.checkDisabilityPensionAndPurchase[lang];
      }
      break;
    case PurchaseRecommendation.NOT_RECOMMENDED:
      if (
        recommendationCauses.includes(RecommendationReason.INCOME) ||
        recommendationCauses.includes(RecommendationReason.DEPENDENTS)
      ) {
        message = adviceUnavailableMessages.notRecommended[lang].replaceAll(
          "{{insurance}}",
          insuranceType,
        );
      }
      break;
    case PurchaseRecommendation.NOT_ONLINE:
      if (recommendationCauses.includes(RecommendationReason.STUDENT)) {
        message = isAdvisor
          ? adviceUnavailableMessages.notOnline.advisor[lang]
          : `${adviceUnavailableMessages.notOnline.part1[lang]}${insuranceType}${adviceUnavailableMessages.notOnline.part2[lang]}`;
      }
      break;
    case PurchaseRecommendation.NOT_ALLOWED:
      if (
        recommendationCauses.includes(RecommendationReason.AGE) ||
        recommendationCauses.includes(RecommendationReason.WORK_SITUATION) ||
        recommendationCauses.includes(RecommendationReason.INCOME)
      ) {
        message = `${adviceUnavailableMessages.notAllowed.part1[lang]}${insuranceType}${causesAsString}${adviceUnavailableMessages.notAllowed.part2[lang]}`;
      }
      break;
    default:
      break;
  }

  return message !== "" ? { insuranceType, message } : null;
};

export const getCausesAsString = (
  insuranceTitle: string,
  causes: RecommendationReason[],
  adviceMessages: any,
  lang: string,
  isAdvisor: boolean,
): string => {
  const causesAsReadableStrings = (causes ?? [])
    .map((cause) => {
      switch (cause) {
        case RecommendationReason.AGE:
          return adviceMessages.causes.age[insuranceTitle][lang];
        case RecommendationReason.WORK_SITUATION:
          return isAdvisor
            ? adviceMessages.causes.workSituationAdvisor[lang]
            : adviceMessages.causes.workSituation[lang];
        case RecommendationReason.INCOME:
          return adviceMessages.causes.income[lang];
        case RecommendationReason.DEPENDENTS:
        default:
          return "";
      }
    })
    .filter((cause) => cause !== "")
    .join(",");
  return causesAsReadableStrings.length !== 0
    ? `${adviceMessages.causes.start[lang]}${causesAsReadableStrings}`
    : "";
};
